import { Component } from '@angular/core';
import { NavigationEnd, Router, ActivatedRoute, NavigationStart } from '@angular/router';
import { filter } from 'rxjs/operators';
import { Title } from '@angular/platform-browser';
import { GraphqlService } from 'src/app/common/services/graphql.service';
import { CommonDataService } from 'src/app/common/services/common-data.service';
import { LoginService } from './common/services/Login.service';
import { SessionService } from './common/services/Session.service';
import { Location } from "@angular/common";
import { GoogleAnalyticsService } from './common/services/google-analytics.service';

declare let gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'GARS-UI';
  showLogin = true;
  acceptedCookie = false;
  urlData;
  currentRole = ""
  IsWhatLinksHere: boolean;
  IsSourceTracingTool:boolean=false;
  navigationData = [];
  currentIdPosition = -1;
  lastCurrentIdPosition = -1;
  backButtonClicked: boolean = false;
  whatLinksHereBackButtonTitle:string="";
  whatLinksHereBackButtonUrl:string="";
  IsGlossary: boolean = false;
  isArchive: boolean = false;
  trackingId;
  pdfBackup: boolean = false;
  constructor(
    private route: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private graphQlService: GraphqlService,
    private loginService: LoginService,
    private location: Location, private _analytics: GoogleAnalyticsService,
    private commonDataService: CommonDataService, private session: SessionService
  ) {
    this._analytics.init();
    /** START : Code to Track Page View using gtag.js */
    this.route.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      this.isArchiveApplication();
      if (session.analticsTrackingId != undefined && session.analticsTrackingId != null && session.analticsTrackingId != "") {
        if (session.analticsTrackingId != "Disabled") {
          gtag('js', new Date());
          //gtag('config', session.analticsTrackingId);
          gtag('config', session.analticsTrackingId.split("~~~~")[0]);
          gtag('config', session.analticsTrackingId.split("~~~~")[1]);
        }
      }
      else
      {
        graphQlService.getAnalyticsTrackingId().subscribe(trackingId => {
          if (trackingId != "" && trackingId != "Disabled") {
            gtag('js', new Date());
            //gtag('config', trackingId);
            gtag('config', trackingId.toString().split("~~~~")[0]);
            gtag('config', trackingId.toString().split("~~~~")[1]);
            session.SetAnalticsTrackingIdValue(trackingId);
          }
        })
      }
    })

    this.location.subscribe((ev) => {
      this.backButtonClicked = true;
      this.crossPageNavigation = true;
    });

    this.route.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe(data => {
        this.urlData = JSON.parse(JSON.stringify(data))
        if (this.urlData.urlAfterRedirects.split('/').includes("GARSpdfs") || this.urlData.urlAfterRedirects.split('/').includes("copy-right-GARSpdfs")
          || this.urlData.urlAfterRedirects.split('/').includes("terms-and-conditions-GARSpdfs")) {
          this.pdfBackup = true;
          this.showLogin = true;
          this.session.assignUserInfo(null);
        }
        else {
          this.pdfBackup = false;
          this.isArchiveApplication();
          if (this.urlData.urlAfterRedirects.split('/').includes("Login")) {
            this.loginService.deleteSession().subscribe();
            this.session.assignUserInfo(null);
            this.showLogin = true;
          }

          if (this.session.userInfo == undefined || this.session.userInfo.user == null) {
            this.loginService.getSession().subscribe(loginData => {
              if (loginData.user != undefined && loginData.user != null && (!this.route.url.includes("Login"))) {
                this.session.assignUserInfo(loginData.user);
                this.currentRole = loginData.user.roles;
                this.showLogin = false;
              }
              else {
                if (!this.route.url.includes("Maintenance") && !this.route.url.includes("GARSpdfs")) {
                  (!this.route.url.includes("proViewLogin")) ? this.route.navigateByUrl("/Login") : this.route.navigateByUrl("/Login/proViewLogin"); this.showLogin = true;
                }
              }
              document.removeEventListener("contextmenu", function (e) {
                e.returnValue = true;
              }, false);

            })
          }
          else {
            if (this.session.userInfo.user != undefined && this.session.userInfo.user != null) {
              this.showLogin = false;
              this.currentRole = this.session.userInfo.user.roles;
            }
            document.removeEventListener("contextmenu", function (e) {
              e.returnValue = true;
            }, false);
          }
        }
      });
    this.route.events
      .pipe(
        filter(event => event instanceof NavigationStart)
      )
      .subscribe((data: NavigationStart) => {
        this.isArchiveApplication();
        this.urlData = JSON.parse(JSON.stringify(data))
        if (data.restoredState) {       // forward and back
          let navId = data.restoredState.navigationId;
          let newId = data.id;

          let replaceAt = this.navigationData.indexOf(navId);//getting the position of id from array where we navigated to
          this.navigationData[replaceAt] = newId;//replacing the id with the new id
          this.lastCurrentIdPosition = this.currentIdPosition;
          this.currentIdPosition = replaceAt;

          this.retainScrollPosition(data);
          this.IsWhatLinksHere = false;
        }
        else {            // when page change on click
          this.navigationData.push(data.id);
          this.lastCurrentIdPosition = this.currentIdPosition;
          this.currentIdPosition = this.navigationData.indexOf(data.id);
          this.retainScrollPosition(data);
        }
      });

  }

  isArchiveApplication() {
    if (localStorage.getItem("publicationId") != undefined && localStorage.getItem("currentVersionPublicationId") != localStorage.getItem("publicationId")) {
      if (this.route.url.split("/").length > 2) {
        this.isArchive = true;
      }
      else if (localStorage.getItem("ArchiveVersion") !== null && localStorage.getItem("ArchiveVersion") !== undefined) {
        this.isArchive = true;
      }
      else {
        this.isArchive = false;
      }
    }
    else if (this.route.url.split("/").length > 2 && !this.route.url.includes("tableOfContent") && !this.route.url.includes("showallinonepage") && this.route.url.split("/")[1] != localStorage.getItem("currentVersionPublicationId")) {
      this.isArchive = true;
    } else { this.isArchive = false; }
  }

  ngOnInit() {
  
    this.isArchiveApplication();
    if (!sessionStorage.getItem('scrollPositionRetentionData')) {
      sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify([]));
    }
    this.route.events.pipe(
      filter(event => event instanceof NavigationEnd),
    ).subscribe(() => {
      const rt = this.getChild(this.activatedRoute);
      rt.data.subscribe(data => {
        this.titleService.setTitle(data.title);
        if (data.title != "General") {
          //this.graphQlService.SetPrintQueueSession(param).subscribe(resp => {
          this.commonDataService.printCount.next("0");
          // });
        }
      });
      this.commonDataService.resetPrintQueue.next(true);
      this.isArchiveApplication();
    });
    this.commonDataService.acceptCookie.subscribe(data => {
      if (data != null && data) {
        //this.graphQlService.getCookie().subscribe(value => {
        // if (value != null && value) {
        this.acceptedCookie = data;
        //  }
        //});
      }
    });
  }

  ngAfterViewChecked() {
    var mainContentClassList = document.getElementsByTagName("app-main-content")[0]?.className;
    var url = this.urlData?.urlAfterRedirects;
    if (url == "/GlossaryTermFinder" || url == "/sourcetracingtool" || url == "/search") {
      if (!mainContentClassList.includes("overflow-hidden-stt")) {
        mainContentClassList += " overflow-hidden-stt";
      }
    }
    else {
      mainContentClassList = mainContentClassList?.replace(" overflow-hidden-stt", "");
    }
    if (mainContentClassList) {
      document.getElementsByTagName("app-main-content")[0].className = mainContentClassList != undefined ? mainContentClassList : "";
    }
  }

  crossPageNavigation: boolean = true;
  retainScrollPosition(data: any) {//scrollPositionRestoration
    if (this.backButtonClicked) {
      sessionStorage.setItem('backButtonClicked', 'true');//setting for pageviewer anchor functionality
      this.backButtonClicked = false;

      let scrollDataArray = JSON.parse(sessionStorage.getItem('scrollPositionRetentionData'));
      let top = document.getElementsByTagName('app-main-content')[0]?.scrollTop;
      let height = document.getElementsByTagName('app-main-content')[0]?.scrollHeight;
      if (top != undefined && height != undefined) {
        if ((typeof scrollDataArray[this.lastCurrentIdPosition] !== 'undefined')) {
          let previousScroll = scrollDataArray[this.lastCurrentIdPosition];
          if (top != previousScroll.scrollTop || height != previousScroll.scrollHeight) {
            scrollDataArray[this.lastCurrentIdPosition].scrollHeight = height;
            scrollDataArray[this.lastCurrentIdPosition].scrollTop = top;
            sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify(scrollDataArray));
          }
        } else {
          scrollDataArray.push({ scrollHeight: height, scrollTop: top });
          sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify(scrollDataArray));
        }
      }

      if (this.crossPageNavigation) {  //|| sessionStorage.getItem('inPageScrollLastUrl') == null
        let currentScrollData = scrollDataArray[this.currentIdPosition];
        let animationCallback = function () {

          let mainContent = document.getElementsByTagName('app-main-content')[0];
          let mainWindowScrollHeight = document.getElementsByTagName('app-main-content')[0]?.scrollHeight;

          if (data.url.includes('Login')) {//for login when clicked on back button
            sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify([]));
          }
          else if (data.url.includes('showallinonepage')) {//for show all in one page
            if (mainContent && currentScrollData != null && currentScrollData?.scrollHeight != null && currentScrollData?.scrollTop != null && currentScrollData?.scrollHeight === mainWindowScrollHeight) {
              document.getElementsByTagName('app-main-content')[0].scrollTop = currentScrollData.scrollTop;
            }
            else {
              setTimeout(() => {
                if (currentScrollData) {
                  currentScrollData.scrollHeight = mainWindowScrollHeight;
                }
              }, 80000);
              requestAnimationFrame(animationCallback);
            }
          }
          else {// for all other pages
            if (mainContent && currentScrollData != null && currentScrollData?.scrollHeight != null && currentScrollData?.scrollTop != null && currentScrollData?.scrollHeight === mainWindowScrollHeight) {
              document.getElementsByTagName('app-main-content')[0].scrollTop = currentScrollData?.scrollTop;
            }
            else {
              setTimeout(() => {
                if (currentScrollData) {
                  currentScrollData.scrollHeight = mainWindowScrollHeight;
                }
              }, 80000);
              requestAnimationFrame(animationCallback);
            }
          }
        }

        let animationFrameRequestID = requestAnimationFrame(animationCallback);
        setTimeout(() => {
          window.cancelAnimationFrame(animationFrameRequestID);
        }, 80000);
      }
    }
    else {
      sessionStorage.setItem('backButtonClicked', 'false');//setting for pageviewer anchor functionality
      if (sessionStorage.getItem('scrollPositionRetentionData')?.length == 0) {
        let scrollDataArray = JSON.parse(sessionStorage.getItem('scrollPositionRetentionData'));
        for (let i = 0; i <= this.lastCurrentIdPosition; i++) {
          scrollDataArray.push({ scrollHeight: 0, scrollTop: 0 });
        }
        sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify(scrollDataArray));
      }
      if (data.url.includes('Login')) {//on logout
        sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify([]));
      }
      else {
        if (data.url == '/') {
          sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify([]));
        }
        else {
          let top = document.getElementsByTagName('app-main-content')[0]?.scrollTop;
          let height = document.getElementsByTagName('app-main-content')[0]?.scrollHeight;
          let scrollDataArray = JSON.parse(sessionStorage.getItem('scrollPositionRetentionData'));
          if (top != undefined && height != undefined) {

            if (typeof scrollDataArray[this.lastCurrentIdPosition] !== 'undefined') {
              let previousScroll = scrollDataArray[this.lastCurrentIdPosition];
              if (top != previousScroll.scrollTop || height != previousScroll.scrollHeight) {
                scrollDataArray[this.lastCurrentIdPosition].scrollHeight = height;
                scrollDataArray[this.lastCurrentIdPosition].scrollTop = top;
                sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify(scrollDataArray));
              }
            } else {
              scrollDataArray.push({ scrollHeight: height, scrollTop: top });
              sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify(scrollDataArray));
            }
          } else {
            for (let i = 0; i <= this.lastCurrentIdPosition; i++) {
              if (scrollDataArray.length < (i + 1)) {
                scrollDataArray.push({ scrollHeight: 0, scrollTop: 0 });
              }
            }
            sessionStorage.setItem('scrollPositionRetentionData', JSON.stringify(scrollDataArray));
          }
        }
      }
    }
  }

  //RetainInPageScroll(scrollDataArray, position, lastPosition, url) {
  //  this.backButtonClicked = false;
  //  sessionStorage.setItem('backButtonClicked', 'false');
  //  var self = this;
  //  let currentScrollData = scrollDataArray[lastPosition];
  //  this.commonDataService.showLoader.next(true);
  //  let top = document.getElementsByTagName('app-main-content')[0]?.scrollTop;
  //  let height = document.getElementsByTagName('app-main-content')[0]?.scrollHeight;
  //  if (top != undefined && height != undefined) {
  //    if (!(typeof scrollDataArray[position] === 'undefined')) {
  //      let previousScroll = scrollDataArray[position];
  //      if (top != previousScroll.scrollTop || height != previousScroll.scrollHeight) {
  //        scrollDataArray[position].scrollHeight = height;
  //        scrollDataArray[position].scrollTop = top;
  //        sessionStorage.setItem('inPageScrollPositionRetentionData', JSON.stringify(scrollDataArray));
  //      }
  //    } else {
  //      scrollDataArray.push({ scrollHeight: height, scrollTop: top, url: url });
  //      sessionStorage.setItem('inPageScrollPositionRetentionData', JSON.stringify(scrollDataArray));
  //    }
  //  }


  //  let animationCallback = function () {

  //    let mainContent = document.getElementsByTagName('app-main-content')[0];
  //    let mainWindowScrollHeight = document.getElementsByTagName('app-main-content')[0]?.scrollHeight;
  //    if (url.includes('showallinonepage')) {//for show all in one page
  //      if (mainContent && currentScrollData != null && currentScrollData?.scrollHeight != null && currentScrollData?.scrollTop != null && currentScrollData?.scrollHeight === mainWindowScrollHeight) {
  //        document.getElementsByTagName('app-main-content')[0].scrollTop = currentScrollData.scrollTop;
  //        self.commonDataService.showLoader.next(false);
  //      }
  //      else {
  //        setTimeout(() => {
  //          if (currentScrollData) {
  //            currentScrollData.scrollHeight = mainWindowScrollHeight;
  //          }
  //        }, 6000);
  //        requestAnimationFrame(animationCallback);
  //      }
  //    }
  //    else {// for all other pages
  //      if (mainContent && currentScrollData != null && currentScrollData?.scrollHeight != null && currentScrollData?.scrollTop != null && currentScrollData?.scrollHeight === mainWindowScrollHeight) {
  //        document.getElementsByTagName('app-main-content')[0].scrollTop = currentScrollData?.scrollTop;
  //        self.commonDataService.showLoader.next(false);
  //      }
  //      else {
  //        setTimeout(() => {
  //          if (currentScrollData) {
  //            currentScrollData.scrollHeight = mainWindowScrollHeight;
  //          }
  //        }, 6000);
  //        requestAnimationFrame(animationCallback);
  //      }
  //    }
  //  }

  //  let animationFrameRequestID = requestAnimationFrame(animationCallback);
  //  setTimeout(() => {
  //    window.cancelAnimationFrame(animationFrameRequestID);
  //  }, 10000);

  //}

  getChild(activatedRoute: ActivatedRoute) {
    if (activatedRoute.firstChild) {
      var obj = this.getChild(activatedRoute.firstChild);
      return obj;
    } else {
      return activatedRoute;
    }

  }
}


